// Header Animation
export const navAnimationLogo = {
  hidden: {
    x: "-100vw",
    opacity: 0,
  },
  visible: {
    x: 0,
    opacity: 1,
    transition: { duration: 1, delay: 1, type: "spring" },
  },
};

// Banner Animations

export const bannerLeftVariant = {
  hidden: {
    x: "-100vw",
    opacity: 0,
  },
  visible: {
    x: 0,
    opacity: 1,
    transition: { duration: 1.5, delay: 1.5, type: "spring" },
  },
};

export const bannerRightVariant = {
  hidden: {
    x: "100vw",
    opacity: 0,
  },
  visible: {
    x: 0,
    opacity: 1,
    transition: { duration: 1.5, delay: 2, type: "spring" },
  },
};

// Services Animations

export const serviceTextAnimation = {
  hidden: {
    y: "-3vw",
    opacity: 0,
  },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 1.5, delay: 1.5, type: "spring" },
  },
};

export const aboutTextAnimation = {
  hidden: {
    y: "-3vw",
    opacity: 0,
  },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 1.5, delay: 1.5, type: "spring" },
  },
};

export const serviceAnimation = {
  hidden: {
    x: "-100vw",
    opacity: 0,
  },
  visible: {
    x: 0,
    opacity: 1,
    transition: { duration: 1.5, delay: 1.5, type: "spring" },
  },
};

/* Testimonial Section Animation */
export const TestimonialTextAnimation = {
  hidden: {
    y: "-3vw",
    opacity: 0,
  },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 1.5, delay: 1, type: "spring" },
  },
};

export const TestimonialAnimation = {
  hidden: {
    y: "3vw",
    opacity: 0,
  },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 1.5, delay: 1, type: "spring" },
  },
};

/* Project Animation */

export const ProjectHeadingText = {
  hidden: {
    y: "-3vw",
    opacity: 0,
  },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 1.5, delay: 1, type: "spring" },
  },
};

export const ProjectSubHeadingText = {
  hidden: {
    y: "3vw",
    opacity: 0,
  },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 1.5, delay: 1, type: "spring" },
  },
};

export const AllProjectsAnimation = {
  hidden: {
    x: "-100vw",
    opacity: 0,
  },
  visible: {
    x: 0,
    opacity: 1,
    transition: { duration: 1.5, delay: 1.5, type: "spring" },
  },
};

/* How I work Section */

export const HowIWorkHeading = {
  hidden: {
    y: "-3vw",
    opacity: 0,
  },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 1.5, delay: 1, type: "spring" },
  },
};

export const HowIWorkSubHeading = {
  hidden: {
    y: "3vw",
    opacity: 0,
  },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 1.5, delay: 1, type: "spring" },
  },
};

export const HowIWorkAllProcess = {
  hidden: {
    y: "3vw",
    opacity: 0,
  },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 1.5, delay: 1, type: "spring" },
  },
};

/* Contact Page Animation */

export const ContactTextAnimation = {
  hidden: {
    y: "-3vw",
    opacity: 0,
  },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 1.5, delay: 1, type: "spring" },
  },
};

export const ContactHeadingAnimation = {
  hidden: {
    y: "3vw",
    opacity: 0,
  },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 1.5, delay: 1.5, type: "spring" },
  },
};

export const ContactLeftAnimation = {
  hidden: {
    x: "-50vw",
    opacity: 0,
  },
  visible: {
    x: 0,
    opacity: 1,
    transition: { duration: 1.5, delay: 1.5, type: "spring" },
  },
};

export const ContactRightAnimation = {
  hidden: {
    x: "50vw",
    opacity: 0,
  },
  visible: {
    x: 0,
    opacity: 1,
    transition: { duration: 1.5, delay: 1.5, type: "spring" },
  },
};
